import { Component } from "react";
import { RotateCw } from "lucide-react";

// Prevents a white screen: if any screen crashes, show a recovery card and retry automatically.
export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
    this.retry = this.retry.bind(this);
    this.onVisible = this.onVisible.bind(this);
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error) {
    console.error("UI crash:", error);
    clearTimeout(this.timer);
    this.timer = setTimeout(this.retry, 5000);
  }

  componentDidMount() {
    document.addEventListener("visibilitychange", this.onVisible);
  }

  componentWillUnmount() {
    clearTimeout(this.timer);
    document.removeEventListener("visibilitychange", this.onVisible);
  }

  onVisible() {
    if (document.visibilityState === "visible" && this.state.error) this.retry();
  }

  retry() {
    this.setState({ error: null });
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="min-h-screen flex items-center justify-center bg-cream p-6" data-testid="error-boundary">
        <div className="max-w-md w-full bg-white border border-border rounded-md p-8 text-center">
          <h1 className="font-heading text-2xl font-bold text-ink mb-2">Reconectando…</h1>
          <p className="text-sm text-cappuccino mb-6">
            A conexão oscilou e a tela foi recarregada por segurança. Tentaremos de novo automaticamente.
          </p>
          <button type="button" onClick={() => window.location.reload()} data-testid="error-boundary-reload"
            className="inline-flex items-center gap-2 bg-gold hover:bg-gold-hover text-ink font-semibold px-5 py-2.5 rounded-md transition-colors">
            <RotateCw className="w-4 h-4" /> Recarregar agora
          </button>
        </div>
      </div>
    );
  }
}
